import { normalizeApiError } from '../api/apiError';
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Requests } from '../api/endpoints/requestsApi';
import { ApiRequestStatus } from "../enums/apiRequestStatus";
import { CreateRequestTaskCommand } from "../models/request/createRequestTaskCommand";

interface requestState {
    isRequestSubmitted: boolean | null;
    submitRequestStatus: ApiRequestStatus;
}

const initialState: requestState = {
    isRequestSubmitted: null,
    submitRequestStatus: ApiRequestStatus.Idle
}

export const submitRequestAsync = createAsyncThunk<boolean, CreateRequestTaskCommand>(
    'requestSlice/submitRequestAsync',
    async (requestCommand, thunkAPI) => {
        try {
            return await Requests.submitRequestAsync(requestCommand);
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const requestSlice = createSlice({
    name: 'requestSlice',
    initialState,
    reducers: {

    },
    extraReducers: (builder => {
        builder.addCase(submitRequestAsync.pending, (state) => {
            state.submitRequestStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(submitRequestAsync.fulfilled, (state, action) => {
            state.isRequestSubmitted = action.payload;
            state.submitRequestStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(submitRequestAsync.rejected, (state) => {
            state.submitRequestStatus = ApiRequestStatus.Rejected;
        });
    })
})
